import { useEffect, useState } from 'react';
import { getSiteContent } from '../../../services/api';
import AboutUsLayout from "../../AboutUsLayout";

const acervoItemsFallback = [
  {
    categoria: "Música",
    categoriaClass: "tag-musica",
    periodo: "1900-1980",
    titulo: "Partituras Históricas",
    descricao:
      "Coleção de partituras originais do século XIX e XX, incluindo composições regionais.",
    quantidade: "230 peças",
  },
  {
    categoria: "Áudio",
    categoriaClass: "tag-audio",
    periodo: "1930-2000",
    titulo: "Documentos Sonoros",
    descricao:
      "Gravações históricas em diversos formatos: fitas cassete, discos de vinil e CDs.",
    quantidade: "450 registros",
  },
  {
    categoria: "Visual",
    categoriaClass: "tag-visual",
    periodo: "1920-1995",
    titulo: "Fotografias",
    descricao:
      "Acervo fotográfico de eventos culturais, artistas e patrimônio histórico de Araraquara.",
    quantidade: "1.200 fotografias",
  },
  {
    categoria: "Arquivo",
    categoriaClass: "tag-arquivo",
    periodo: "1930-1979",
    titulo: "Conservatório Musical Joaquim Franco",
    descricao:
      "Documentação completa do Conservatório Musical (1930-1979), incluindo programas, certificados e registros administrativos.",
    quantidade: "500+ documentos",
  },
  {
    categoria: "Bibliografia",
    categoriaClass: "tag-bibliografia",
    periodo: "1950-2020",
    titulo: "Biblioteca Especializada",
    descricao:
      "Livros e periódicos sobre música, cultura e história regional de Araraquara.",
    quantidade: "800 volumes",
  },
  {
    categoria: "Vídeo",
    categoriaClass: "tag-video",
    periodo: "1970-2010",
    titulo: "Material Audiovisual",
    descricao:
      "Vídeos de apresentações, entrevistas com artistas e documentários sobre cultura regional.",
    quantidade: "150 registros",
  },
];

const getCategoryClass = (cat) => {
  if (!cat) return 'tag-outros';
  const clean = cat
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]/g, '');
  return `tag-${clean}`;
};

export default function Home() {
  const [history, setHistory] = useState('');
  const [acervo, setAcervo] = useState([]);
  const [youtubeLink, setYoutubeLink] = useState('');
  const [youtubeText, setYoutubeText] = useState('');
  const [acervoTitle, setAcervoTitle] = useState('');
  const [youtubeTitle, setYoutubeTitle] = useState('');
  const [acervoGridTitle, setAcervoGridTitle] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await getSiteContent();
        if (data.length > 0) {
          const item = data[0];
          if (item.history) {
            setHistory(item.history);
          }
          if (item.acervo && item.acervo.length > 0) {
            setAcervo(item.acervo);
          }
          if (item.youtubeLink) {
            setYoutubeLink(item.youtubeLink);
          }
          if (item.youtubeText) {
            setYoutubeText(item.youtubeText);
          }
          if (item.acervoTitle) {
            setAcervoTitle(item.acervoTitle);
          }
          if (item.youtubeTitle) {
            setYoutubeTitle(item.youtubeTitle);
          }
          if (item.acervoGridTitle) {
            setAcervoGridTitle(item.acervoGridTitle);
          }
        }
      } catch (err) {
        console.error('Erro ao buscar conteúdo do acervo:', err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const itemsToRender = acervo.length > 0
    ? acervo.map(item => ({
        categoria: item.category,
        categoriaClass: getCategoryClass(item.category),
        periodo: item.period,
        titulo: item.title,
        descricao: item.description,
        quantidade: item.quantity,
      }))
    : acervoItemsFallback;

  if (loading) {
    return (
      <AboutUsLayout activePage="acervo">
        <main className="home-main" />
      </AboutUsLayout>
    );
  }

  return (
    <AboutUsLayout activePage="acervo">
      <main className="home-main">
        {/* Intro Card */}
        <section className="home-intro-card">
          <h1 className="home-intro-title">{acervoTitle || 'Acervo de Artes CEDOMCA'}</h1>
          {history ? (
            history.split('\n').filter(p => p.trim()).map((para, i) => (
              <p className="home-intro-text" key={i}>
                {para}
              </p>
            ))
          ) : (
            <>
              <p className="home-intro-text">
                  Bem-vindo ao Laboratório e Centro de Documentação e Memória da Cultura na Amazônia (CEDOMCA), o acervo da Faculdade de Artes da Universidade Federal do Amazonas (UFAM). Nós somos uma equipe dedicada de professores e estudantes que trabalham juntos para preservar e compartilhar a rica história da arte na região amazônica.
              </p>
              <p className="home-intro-text">
                    O Laboratório e Centro de Documentação e Memória da Cultura na Amazônia (CEDOMCA) foi criado
                    em 23 de janeiro de 2018, na Faculdade de Artes da Universidade Federal do Amazonas, tendo
                    como finalidades: 1) a salvaguarda da memória da cultura na Amazônia, presentificada em &ldquo;documentos&rdquo;
                    que compõem o seu acervo; 2) a acessibilidade do seu acervo para o público vasto - pesquisadores,
                    estudantes e público em geral e; 3) o fomento do ensino, de pesquisas, ações de extensão e exposições
                    a partir de seu acervo, além da colaboração nas demais exposições e ações cujo acervo possui afinidades.
              </p>
              <p className="home-intro-text">
                    O CEDOMCA tem parceria multidisciplinar com as Ciências da Informação, com os procedimentos da Arquivologia,
                    com a Museologia e com a Biblioteconomia. Estes campos contribuem para as ações de trabalho mais técnico de
                    tratamento e guarda de documentos.
              </p>
              <p className="home-intro-text">
                    O acervo do CEDOMCA é constituído, a princípio, por um conjunto de livros, bibliografias, LPs oriundos
                    do extinto Conservatório Musical &ldquo;Joaquim Franco&rdquo;(1965-1978); dos livros pertencentes a biblioteca
                    particular da artista Bernadete Andrade (1953-2007); cópias de partituras de Arnaldo Rebello (1905-1987)
                    e Lindalva Cruz (1908-2005); dissertações e teses temáticas da Cultura Amazônica; coleção de LPs temáticos
                    da cultura dos povos tradicionais do Brasil; gravações em áudio de cantos, danças e rituais dos povos da floresta, entre outros materiais.
              </p>
            </>
          )}
        </section>

        {/* YouTube Playlist */}
        <section className="home-youtube-card">
          <span className="home-youtube-icon-box" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="28" height="28" xmlns="http://www.w3.org/2000/svg" fill="#fff">
              <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
            </svg>
          </span>
          <div className="home-youtube-content">
            <p className="home-youtube-label">YouTube</p>
            <p className="home-youtube-title">{youtubeTitle || 'Playlist CEDOMCA'}</p>
            <p className="home-youtube-subtitle">
              {youtubeText || 'Vídeos sobre o acervo, entrevistas e conteúdos sobre cultura e memória amazônica.'}
            </p>
          </div>
          <a
            className="home-youtube-btn"
            href={youtubeLink || 'https://youtube.com/playlist?list=PLpPGbI2fk_PYfrUhmX_KjVsC6EfE02ZUx&si=WK0JAhftraNGicd8'}
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true">
              <polygon points="5,3 19,12 5,21"/>
            </svg>
            Assistir playlist
          </a>
        </section>

        {/* Grid */}
        <section className="home-grid-section">
          <h2 className="home-grid-title">{acervoGridTitle || 'Explore o Acervo'}</h2>
          <div className="home-grid">
            {itemsToRender.map((item, i) => (
              <article className="home-card" key={i}>
                <div className="home-card-header">
                  <span className={`home-tag ${item.categoriaClass}`}>
                    {item.categoria}
                  </span>
                  {item.periodo && <span className="home-card-periodo">{item.periodo}</span>}
                </div>
                <h3 className="home-card-title">{item.titulo}</h3>
                <p className="home-card-desc">{item.descricao}</p>
                {item.quantidade && <span className="home-card-qty">{item.quantidade}</span>}
              </article>
            ))}
          </div>
        </section>
      </main>
    </AboutUsLayout>
  );
}
